<template>
  <div class="tables">
    <Tables :columns="columns" :dataSource="dataSource" :data="data">
      <td style="width: 200px;" slot="actions" slot-scope="item">
        <div class="actions-buttons">
          <b-button
            class="bgi-buttons"
            @click="goToDesktop(item.item)"
            v-b-tooltip.hover.left
            :title="setPermissions(item.item).tooltipMsg"
          >
            <i :class="setPermissions(item.item).icon"></i>
          </b-button>
          <b-button
            class="bgi-buttons"
            v-b-tooltip.hover.left
            title="Configuraciones"
            v-if="showButton(item.item)"
            @click="redirect(item.item)"
          >
            <i class="bx bx-wrench"></i>
          </b-button>

          <b-button
            v-if="showButton(item.item)"
            class="bgi-buttons"
            v-b-tooltip.hover.left
            title="Descargar PDF"
            @click="descargarPdf(item.item)"
          >
            <i class="bx bx-download"></i>
          </b-button>

          <b-button
            v-if="estadoButton(item.item)"
            @click="approveReject('aprobado', item.item)"
            class="bgi-buttons"
            v-b-tooltip.hover.left
            title="Aprobar"
          >
            <i class="bx bx-check"></i>
          </b-button>

          <b-button
            v-if="estadoButtonRechazar(item.item)"
            @click="approveReject('rechazado', item.item)"
            class="bgi-buttons"
            v-b-tooltip.hover.left
            title="Rechazar"
          >
            <i class="bx bx-x"></i>
          </b-button>
        </div>
      </td>
    </Tables>

    <b-modal v-model="commentsModal" hide-footer hide-header>
      <MsgModal
        :revisionData="revisionData"
        :closeCommentModal="closeCommentModal"
        :obtener="obtener"
      />
    </b-modal>
  </div>
</template>

<script>
import Tables from "../../../components/tables/Tables.vue";
import axios from "axios";
// import Aproved from "./Aproved.vue";
import { showAlert } from "../../../components/tools/utils";
import MsgModal from "./MsgModal.vue";
import { mapState } from "vuex";
import Swal from "sweetalert2";
export default {
  props: ["toSearch"],

  components: {
    Tables,
    MsgModal,
    // Aproved,
  },
  data() {
    return {
      columns: [
        "Ministerio",
        "Servicio",
        "Estado",
        "%Avance",
        "Perfil Usuario",
      ],
      dataTable: null,
      avance: null,
      dataSource: [],
      estado: null,
      funcionario: true,
      bgi: false,
      jefe: false,
      rep: false,
      admi: false,
      superAdmin: false,
      commentsModal: false,
      revisionData: null,
      adminName: process.env.VUE_APP_USER_ADMIN,
      loading: true,
      revision: 100,
      estadoDate: "finalizado",
      datosRes: [],
      estadoBack: null,
      data: null,
      list: null,
    };
  },
  watch: {
    toSearch: function() {
      if (this.toSearch.length === 0) {
        this.data = this.dataSource;
        return;
      }
      this.data = this.dataSource.filter((s) =>
        s.servicio.toLowerCase().includes(this.toSearch.toLowerCase())
      );
    },
  },

  computed: {
    ...mapState("items", ["items"]),
    ...mapState("sesion", ["usuario"]),
  },
  methods: {
    obtener: async function() {
      try {
        if (this.dataSource !== null) {
          this.dataSource = [];
        }

        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/avance/`,
          {
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        this.dataTable = Object.values(res.data);
        this.dataTable.forEach((d) => {
          if (d.avance[process.env.VUE_APP_ANIO] === undefined) {
            this.avance = "0";
          } else {
            this.avance =
              d.avance[process.env.VUE_APP_ANIO].porcentajeTotalAvance;
          }

          //Sin estado           //Encargado BGI
          if (d.estadoRevision[process.env.VUE_APP_ANIO] === undefined) {
            this.estado = "En elaboración";
          }
          //Jefe de Serrvicio
          else if (
            d.estadoRevision[process.env.VUE_APP_ANIO].siguienteAccion ===
            "jefe_servicio"
          ) {
            this.estado = "En revisión Jefe de Servicio";
          }
          //Rep. Ministerial
          else if (
            d.estadoRevision[process.env.VUE_APP_ANIO].siguienteAccion ===
            "representante_ministerial"
          ) {
            this.estado = "En revisión Representante Ministerial";
          }
          //Administrado de la dipres
          else if (
            d.estadoRevision[process.env.VUE_APP_ANIO].siguienteAccion ===
            "administrador"
          ) {
            this.estado = "En revisión Administrador";
          }
          //Super Adminsitrador
          else if (
            d.estadoRevision[process.env.VUE_APP_ANIO].siguienteAccion ===
            "superadministrador"
          ) {
            this.estado = "En revisión Super Administrador";
          } else if (
            d.estadoRevision[process.env.VUE_APP_ANIO].siguienteAccion ===
            "encargado_bgi"
          ) {
            this.estado = "En elaboración";
          } else if (
            d.estadoRevision[process.env.VUE_APP_ANIO].a === "finalizado"
          ) {
            this.estado = "Proceso BGI Finalizado";
          } else {
            this.estado = "En elaboración";
          }
          this.dataSource.push({
            ministerio: d.ministerio.nombre,
            servicio: d.servicio.nombre,
            idServicio: d.servicio.id,
            rol: d.rol,
            avance: this.avance,
            estado: this.estado,
          });
        });

        this.dataSource.sort(function(a, b) {
          if (a.orderBy > b.orderBy) {
            return 1;
          }
          if (a.orderBy < b.orderBy) {
            return -1;
          }
          return 0;
        });
        this.data = this.dataSource;
        console.log("hOLAaaaaa MUNDO0000", this.data);
      } catch (error) {
        console.log(error);
      }
    },

    setPermissions: function(item) {
      let objRet = {};
      if (
        item.rolId === 6 ||
        item.rolId === 4 ||
        item.rolId === 3 ||
        item.rolId === 2 ||
        this.usuario.username === process.env.VUE_APP_USER_ADMIN
      ) {
        objRet.tooltipMsg = "Revisar";
        objRet.icon = "bx bx-show";
      } else {
        objRet.tooltipMsg = "Completar";
        objRet.icon = "bx bx-edit-alt";
      }

      return objRet;
    },

    showButton: function(item) {
      if (this.usuario.username === process.env.VUE_APP_USER_ADMIN) return true;

      if (item.rol !== "funcionario") {
        return true;
      } else {
        return false;
      }
    },

    goToDesktop(item) {
      this.$router.push({
        name: "buttons",
        params: {
          idUsuario: this.$route.params.idUsuario,
          idServicio: item.idServicio,
        },
      });
    },

    redirect: function(item) {
      if (item.rol === "funcionario") return;
      this.$router.push({
        name: "acceso",
        params: {
          idServicio: item.idServicio,
          idUsuario: this.$route.params.idUsuario,
        },
      });
    },

    estadoButton: function(item) {
      if (item.rol === "funcionario") {
        return false;
      }
      //Encargado BGI
      else if (
        item.rol === "encargado_bgi" &&
        item.estado === "En elaboración"
      ) {
        return true;
      } else if (
        item.rol === "encargado_bgi" &&
        item.estado === "Sin registro"
      ) {
        return true;
      }
      //Jefe de Servicio
      else if (
        item.rol === "jefe_servicio" &&
        item.estado === "En revisión Jefe de Servicio"
      ) {
        return true;
      }
      //Rep. Ministerial
      else if (
        item.rol === "representante_ministerial" &&
        item.estado === "En revisión Representante Ministerial"
      ) {
        return true;
      }
      // Admin Dipres
      else if (
        item.rol === "administrador" &&
        item.estado === "En revisión Administrador"
      ) {
        return true;
      }
      // Super Adminsitrador
      else if (
        item.rol === "superadministrador" &&
        item.estado === "En revisión Super Administrador"
      ) {
        return true;
      } else {
        return false;
      }
    },

    estadoButtonRechazar: function(item) {
      if (item.rol === "funcionario") {
        return false;
      }
      //Encargado BGI
      else if (
        item.rol === "encargado_bgi" &&
        item.estado === "En elaboración"
      ) {
        return false;
      }
      //Jefe de Servicio
      else if (
        item.rol === "jefe_servicio" &&
        item.estado === "En revisión Jefe de Servicio"
      ) {
        return true;
      }
      //Rep. Ministerial
      else if (
        item.rol === "representante_ministerial" &&
        item.estado === "En revisión Representante Ministerial"
      ) {
        return true;
      }
      // Admin Dipres
      else if (
        item.rol === "administrador" &&
        item.estado === "En revisión Administrador"
      ) {
        return true;
      }
      // Super Adminsitrador
      else if (
        item.rol === "superadministrador" &&
        item.estado === "En revisión Super Administrador"
      ) {
        return true;
      } else {
        return false;
      }
    },

    descargarPdf: async function(item) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 15000,
        timerProgressBar: true,
      });
      try {
        Toast.fire({
          icon: "success",
          title: "El PDF se está generando.",
        });

        console.log(item);
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/${item.idServicio}/pdf_generate/?anio=${process.env.VUE_APP_ANIO}`,
          {
            responseType: "blob",
            headers: {
              Authorization: `JWT ${localStorage.getItem("userToken")}`,
            },
          }
        );

        var blob = new Blob([res.data], { type: "application/pdf" });

        var URL = window.URL || window.webkitURL;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = url;
        link.setAttribute(
          "download",
          `BGI_${item.servicio}_${process.env.VUE_APP_ANIO}.pdf`
        );

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        Toast.close();
        showAlert({
          icon: "error",
          text: "Ha ocurrido un error en la generación del PDF.",
          timerProgressBar: true,
          timer: 3000,
        });
      }
    },

    closeCommentModal: function() {
      this.commentsModal = false;
    },
    approveReject: async function(type, item) {
      // if (this.revision !== 100) {
      //   showAlert({
      //     icon: "error",
      //     text: "Solo estara cuando los modulos esten completos",
      //     timerProgressBar: true,
      //     timer: 3000,
      //   });
      // } else {
      this.commentsModal = true;
      console.log("Hola mundo");
      this.revisionData = {
        tipo: type,
        anio: process.env.VUE_APP_ANIO,
        idServicio: item.idServicio,
        mensaje: "",
        // };
      };
      // this.obtener();
    },
  },
  mounted() {
    this.obtener();
    // this.estadoButton();
  },
};
</script>

<style scoped>
.actions-buttons {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}
.bgi-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #052333;
  color: #fff;
}

.bgi-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #052333;
  color: #fff;
  width: 30px;
  height: 30px;
  font-size: 12px;
  border-radius: 50%;
  margin-right: 5px;
}

.bgi-buttons:hover {
  background: #052333;
  color: #fff;
}
</style>
